import { tileServer, tileOpacity } from './../config/config';

class MapService {
    changeRegion(region) {
        this.map.setOptions(region.mapOptions);
    }

    initializeMap(mapElement) {
        const self = this;
        self.map = new google.maps.Map(mapElement, {
            panControl: false,
            streetViewControl: false,
            zoomControl: true,
            active: true,
            fullscreenControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            }
        });

        // get tile layer
        const cachelayer = new google.maps.ImageMapType({
            getTileUrl: function(coord, zoom) {
                const normalizedCoord = getNormalizedCoord(coord, zoom);
                if (!normalizedCoord) {
                    return;
                }
                return `${tileServer}/${parseFloat(zoom)}/${normalizedCoord.y}/${normalizedCoord.x}`;
            },
            tileSize: new google.maps.Size(256, 256),
            opacity: tileOpacity
        });

        // function copied from the google api reference
        function getNormalizedCoord(coord, zoom) {
            const y = coord.y;
            let x = coord.x;

            // tile range in one direction range is dependent on zoom level
            // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc
            const tileRange = 1 << zoom;

            // don't repeat across y-axis (vertically)
            if (y < 0 || y >= tileRange) {
                return null;
            }

            // repeat across x-axis
            if (x < 0 || x >= tileRange) {
                x = (x % tileRange + tileRange) % tileRange;
            }

            return { x, y };
        }

        self.map.overlayMapTypes.push(cachelayer);
        self.geocoder = new google.maps.Geocoder();
        new google.maps.places.PlacesService(self.map);
    }

    initializeSearch(searchElement, searchCallback) {
        const self = this;
        this.searchCallback = searchCallback;
        const autocomplete = new google.maps.places.Autocomplete(searchElement);
        autocomplete.addListener('place_changed', () => onPlaceChanged(this));

        function onPlaceChanged(mapService) {
            const place = autocomplete.getPlace();
            mapService.setPlace(place);
            self.searchCallback(place, google.maps.GeocoderStatus.OK);
        }
    }

    searchLocation(searchStr) {
        const self = this;
        self.geocoder.geocode({ address: searchStr }, (results, status) => {
            let place = null;
            if (status === google.maps.GeocoderStatus.OK) {
                place = results[0];
                self.setPlace(place);
            }
            self.searchCallback(place, status);
        });
    }

    setPlace(place) {
        let gmarkers = [];
        if (place.geometry) {
            for (let i = 0; i < gmarkers.length; i++) {
                gmarkers[i].setMap(this.map);
            }

            gmarkers = [];
            const marker = new google.maps.Marker({
                position: place.geometry.location
            });
            gmarkers.push(marker);
            marker.setMap(this.map);
            this.map.panTo(place.geometry.location);
            this.map.setZoom(15);
        }
    }
}

export default new MapService();
